"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TextInput = (_a) => {
    var { label, name, className, errors = [], number = false } = _a, props = __rest(_a, ["label", "name", "className", "errors", "number"]);
    return (react_1.default.createElement("div", { className: className },
        label && (react_1.default.createElement("label", { className: "form-label", htmlFor: name },
            label,
            ":")),
        react_1.default.createElement("input", Object.assign({ id: name, name: name }, props, { className: `form-input ${errors.length ? "error" : ""}`, pattern: number ? "[0-9]{1,4}" : undefined })),
        errors && react_1.default.createElement("div", { className: "form-error" }, errors)));
};
exports.default = TextInput;
